module.exports = __webpack_public_path__ + "img/lecture_offline1.7beb6dbc.png";